var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-section report-section-footer"},[_c('p',[_vm._v(_vm._s(_vm.reportData.company))]),_c('p',{staticStyle:{"margin-top":"5px"}},[_vm._v(_vm._s(_vm.reportData.copyright))])])
}
var staticRenderFns = []

export { render, staticRenderFns }